import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { reduxForm, Field, getFormValues } from 'redux-form';
import faCheck from '@fortawesome/fontawesome-pro-light/faCheck';

import { bookingFormInitialValues } from '../store/reducers';
import Select from './Select';
import { setStep } from '../store/actions';
import Language from '../enums/Language';
import Currency from '../enums/Currency';
import withLocalize from '../withLocalize';
import faArrowToRight from "@fortawesome/fontawesome-pro-light/faArrowToRight";
import faArrowFromLeft from "@fortawesome/fontawesome-pro-light/faArrowFromLeft";
import {getNoOfNights, isPackagesStepVisible} from "../apiHelpers";
import { formatDateToYMD } from '../structuredData';
import faMoon from "@fortawesome/fontawesome-pro-light/faMoon";

class Header extends Component {

	handleClickSetStep = (e, step) => {
		e.preventDefault();

		const { dispatch, maxStep } = this.props;

		if (step > maxStep) return;

		dispatch(setStep(step));
	};

	render() {
		const { step: currentStep, currencies, translate: t, formValues, packages, apiRoomsResponse } = this.props;

		if ( currentStep > 5 ) return null;

		// Krok s pobytovými balíčky (krok 3) se zobrazí jen tehdy, když jsou balíčky dostupné.
		// Jinak ho z paginátoru vynecháme a zbylé kroky přečíslujeme, aby nevznikla mezera.
		const packageIds = apiRoomsResponse ? apiRoomsResponse.packageIds : null;
		const steps = isPackagesStepVisible(packages, packageIds, formValues)
			? [1, 2, 3, 4, 5]
			: [1, 2, 4, 5];

		// Na Step2 čte crawler Googlu termín pobytu
		const itineraryProps = (itemProp, date) => currentStep === 2 ? { itemProp, content: formatDateToYMD(date) } : {};

		return (
            <header className="header">
				<ul className="header-paginator">
					{steps.map((step, index) => (
						<li className="header-paginator__item" key={step}>
							<button
								className={`
									header-paginator__link
									${step < currentStep ? 'header-paginator__link--success' : ''}
									${step === currentStep ? 'header-paginator__link--current' : ''}
								`}
								onClick={e => this.handleClickSetStep(e, step)}
							>
								{step < currentStep ?
									<FontAwesomeIcon icon={faCheck} />
									:
									index + 1
								}
							</button>
						</li>
					))}
				</ul>

                {currentStep > 1 && (
                    <div className="header-selected-range header-desktop">
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faMoon}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.nights')}</label>
                            </div>
                            <span style={{paddingLeft: "2px"}}>{getNoOfNights(formValues.arrival, formValues.departure)}</span>
                        </div>
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faArrowToRight}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.arrival')}</label>
                            </div>
                            <span {...itineraryProps('checkinTime', formValues.arrival)}>{formValues.arrival}</span>
                        </div>
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faArrowFromLeft}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.departure')}</label>
                            </div>
                            <span {...itineraryProps('checkoutTime', formValues.departure)}>{formValues.departure}</span>
                        </div>
                    </div>
                )}

				<div className="header-currency">
					<Field
						component={Select}
						name="currency"
						label={t('Header.currency')}
						options={Currency.getOptions(currencies)}
						format={(value) => value.id}
						normalize={(value) => currencies[value]}
						className="select-container--header"
					/>

					<Field
						component={Select}
						name="lang"
						label={t('Header.language')}
						options={Language.getOptions()}
						className="select-container--header"
					/>

				</div>

                {currentStep > 1 && (
                    <div className="header-selected-range header-mobile" style={{gap: "40px"}}>
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faMoon}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.nights')}</label>
                            </div>
                            <span style={{paddingLeft: "2px"}}>{getNoOfNights(formValues.arrival, formValues.departure)}</span>
                        </div>
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faArrowToRight}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.arrival')}</label>
                            </div>
                            <span {...itineraryProps('checkinTime', formValues.arrival)}>{formValues.arrival}</span>
                        </div>
                        <div className="header-selected-range--item">
                            <div className="header-selected-range--item-header">
                                <FontAwesomeIcon
                                    icon={faArrowFromLeft}
                                    className="header-selected-range--item-icon"
                                />
                                <label>{t('DepartureArrival.departure')}</label>
                            </div>
                            <span {...itineraryProps('checkoutTime', formValues.departure)}>{formValues.departure}</span>
                        </div>
                    </div>
                )}
            </header>
		);
	}
}

export default compose(
	withRouter,
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		step: state.app.step,
		maxStep: state.app.maxStep,
		currencies: state.app.currencies,
		packages: state.app.packages || {},
		apiRoomsResponse: state.app.apiRoomsResponse,
        formValues: getFormValues('bookingForm')(state),
	})),
	withLocalize,
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx